/**
 * RF-07 · Reparto de trabajo sobre los indicadores.
 *
 * Tres tareas: `evidencias`, `instrumentos` y `calificar`. Una asignación sin
 * indicador designa al responsable del proceso.
 *
 * No hay actualización: cambiar una asignación es borrarla y crearla, para no
 * sobrescribir el rastro de quién estuvo asignado.
 *
 * Store Pinia: estado compartido del módulo y orquestación de sus servicios.
 * Las vistas no llaman a `http` ni a los servicios directamente; pasan por aquí.
 * Los servicios no lanzan, así que las acciones interpretan valores neutros
 * (`[]`, `null`, `false`) como fallo.
 */

import { defineStore } from 'pinia'
import type IndicadorEvaluador from '@/interfaces/IndicadorEvaluador'
import { getIndicadorEvaluadoresService, crearIndicadorEvaluadorService, eliminarIndicadorEvaluadorService} from '@/services/IndicadorEvaluadorService'

/** Store `indicadorEvaluadores`. Ver la cabecera del archivo para el contrato del módulo. */
export const useGestionIndicadorEvaluadores = defineStore('indicadorEvaluadores', {
  state: () => ({
    asignaciones: [] as IndicadorEvaluador[],
    misAsignaciones: [] as IndicadorEvaluador[]
  }),

  actions: {
    async cargar(params: { id_version?: number; id_indicador?: number; id_usuario?: number; tarea?: string; id_ejecucion?: number }): Promise<void> {
      this.asignaciones = await getIndicadorEvaluadoresService(params)
    },

    async cargarMisAsignaciones(id_usuario: number): Promise<void> {
      this.misAsignaciones = await getIndicadorEvaluadoresService({ id_usuario })
    },

    async asignar(
      data: Omit<IndicadorEvaluador, 'id'>
    ): Promise<{ ok: boolean; data?: IndicadorEvaluador; errors?: Record<string, string[]> }> {
      const result = await crearIndicadorEvaluadorService(data)
      if (result.ok && result.data) {
        this.asignaciones.push(result.data)
      }
      return result
    },

    async eliminar(id: number): Promise<{ ok: boolean; errors?: Record<string, string[]> }> {
      const result = await eliminarIndicadorEvaluadorService(id)
      if (result.ok) {
        this.asignaciones = this.asignaciones.filter(a => a.id !== id)
      }
      return result
    }
  }
})
